
import "../css/navbar.css"
import React, { useState, useEffect } from "react";
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';


export default function Navbar({ mb, logReg, notification, trolly, userData }) {
    const [filter, setFilter] = useState(' ');
    const navigate = useNavigate();
    const [cookies, setCookie] = useCookies(['accessToken', 'user', 'event']);
    const [user, setUser] = React.useState({});
    const [link, setLink] = useState('/')

    React.useEffect(() => {
        const validateAccessToken = async () => {
            try {
                const url = 'https://w-shop-backend.vercel.app/api/auth/whoami';
                const rawResponse = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-type': 'application/json',
                        'Authorization': 'Bearer ' + cookies.accessToken,
                    },
                })
                const response = await rawResponse.json();
                if (response.status !== 'success' && response.data.role !== 'buyer' && response.data.role !== 'admin') {
                    throw new Error();
                }
                setUser(response.data);
            } catch (error) {
                setCookie('accessToken', '', { path: '/' });
                navigate('/');
            }
        }
        if (cookies.accessToken === '') {
            setLink('/')
        } else {
            validateAccessToken();
            setLink('/home')
        }
    }, [cookies.accessToken, navigate, setCookie])

    useEffect(() => {
        userData(user)
    }, [user, userData]);

    return (
        <div className="header">
            <div className="container d-flex pt-2 nt">
                {mb}
                <p className="navbar-top ms-2 ms-sm-0 d-none d-md-block">Ikuti Kami</p>
                <a href="-" ><img src={"/img/facebook.png"} className="img-navbar-top ms-3 pt-1 d-none d-md-block" alt="" /></a>
                <a href="-" ><img src={"/img/instagram.png"} className="img-navbar-top ms-3 pt-1 d-none d-md-block" alt="" /></a>
                <a href="-" ><img src={"/img/twitter.png"} className="img-navbar-top ms-3 pt-1 d-none d-md-block" alt="" /></a>
                {notification}
                {logReg}
            </div>

            <nav className="navbar navbar-expand-lg pb-3">
                <div className="container">
                    <a className="navbar-brand d-flex" href={link}>
                        <img src={"/img/logo.png"} className="img-log" alt="img-logo" width={60} height={60}></img>
                        <div className="logo-title  ps-2">W-Shop</div></a>
                    <a href="/search" className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
                        <span className="navbar-toggler-icon"></span>
                    </a>
                    <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
                        <div className="offcanvas-header">
                            <a className="navbar-brand d-flex" href="/">
                                <img src={"/img/logo.png"} className="img-log" alt="img-logo" width={60} height={60}></img>
                                <div className="logo-sidebar  ps-2">W-Shop</div></a>
                            <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                        </div>
                        <div className="offcanvas-body">
                            <form className="d-flex  ms-auto me-0 ms-md-auto me-md-auto    search border rounded p-1 bg-light" role="search">
                                <input className="form-control me-1" type="search" placeholder="Cari" aria-label="Search"
                                    onChange={(e) => {
                                        setFilter(old => {
                                            const val = e.target.value;
                                            if (val === '') {
                                                delete old.product;
                                                return old;
                                            };
                                            return {
                                                product: val,
                                            }
                                        })
                                    }} />
                                <button className="btn btn-search btn-primary" type="button"
                                    onClick={() => {
                                        navigate('/search?product=' + filter.product + '&page=1')
                                    }}>
                                    <img src={"/img/icon-search.png"} className="img-log" alt="img-logo" width={20} height={20}></img>
                                </button>
                            </form>
                            {trolly}
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    )
}